import Keycloak from "keycloak-js";

let keycloakInstance = null;
let isInitialized = false;

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || "https://iam.idvilnius.lt",
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "idvilnius",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "judumas",
  checkLoginIframe: false,
};

export const initKeycloak = async () => {
  if (typeof window !== "undefined" && !isInitialized) {
    isInitialized = true;
    keycloakInstance = new Keycloak(keycloakConfig);

    try {
      const authenticated = await keycloakInstance.init({
        onLoad: "login-required",
        pkceMethod: "S256",
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      });

      if (authenticated) {
        console.log("User authenticated with Keycloak");
        // Set up token refresh
        setInterval(async () => {
          try {
            await keycloakInstance.updateToken(70);
          } catch (error) {
            console.error("Failed to refresh Keycloak token, redirecting to login", error);
            keycloakInstance.login();
          }
        }, 6000);
      }
    } catch (error) {
      console.error("Keycloak initialization failed", error);
      keycloakInstance = null;
    }
  }
  return keycloakInstance;
};

export { keycloakInstance };
